(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["safari-cart-chat"] && !Shopify.designMode) return;
  try {
    (() => {
    let frame = 0;
    const observed = new WeakSet();
    const overlaps = (a, b) => a.left < b.right + 8 && a.right > b.left - 8 && a.top < b.bottom + 8 && a.bottom > b.top - 8;
    const visible = (element) => {
      const rect = element.getBoundingClientRect();
      const style = getComputedStyle(element);
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    };
    const update = () => {
      frame = 0;
      const chat = document.querySelector('shopify-chat');
      const activator = chat?.shadowRoot?.querySelector('[part="activator"]');
      if (!chat || !activator) return;
      const sticky = document.querySelector('.sticky-atc');
      const bottom = sticky && visible(sticky) ? Math.max(80, innerHeight - sticky.getBoundingClientRect().top + 16) : 80;
      chat.style.setProperty('--safari-chat-bottom', `${Math.ceil(bottom)}px`);
      const chatRect = activator.getBoundingClientRect();
      const blocked = [...document.querySelectorAll('button[name="add"], button[name="checkout"], .shopify-payment-button')]
        .some(button => visible(button) && overlaps(chatRect, button.getBoundingClientRect()));
      chat.toggleAttribute('data-safari-overlap', blocked && activator.getAttribute('aria-expanded') !== 'true');
      if (sticky && !observed.has(sticky)) {
        observed.add(sticky);
        sizes.observe(sticky);
      }
      if (!observed.has(activator)) {
        observed.add(activator);
        sizes.observe(activator);
      }
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const sizes = new ResizeObserver(schedule);
    const start = () => {
      document.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      document.addEventListener('shopify:section:load', schedule);
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
      customElements.whenDefined('shopify-chat').then(schedule);
      schedule();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
